import React from "react";
import Pagination from "./Pagination";

const BottomBar = ({ page, setPage, maxPage }) => {
    return <Pagination page={page} setPage={setPage} maxPage={maxPage} />;
};

export default BottomBar;
